/* eslint-disable max-len */

export type DeleteReservationReq = undefined
export type DeleteReservationRes = void
  
export const DELETE_RESERVATION = '/v1/reservations/:pk/'
